import { processDefaultValidationError } from './processDefaultValidationError.esm.js';
import { processDeprecatedTestsError } from './processDeprecatedTestsError.esm.js';
import { processLocationValidationError } from './processLocationValidationError.esm.js';
import { processRnaUnsupportedCountryValidationError } from './processRnaUnsupportedCountryValidationError.esm.js';

var useMakePostProcessingActions = function () {
    return {
        processDefaultValidationError: processDefaultValidationError,
        processDeprecatedTestsError: processDeprecatedTestsError,
        processLocationValidationError: processLocationValidationError,
        processRnaUnsupportedCountryValidationError: processRnaUnsupportedCountryValidationError,
    };
};

export { useMakePostProcessingActions };
//# sourceMappingURL=index.esm.js.map
